class FacetFiltersForm extends HTMLElement {
  static filterData = [];

  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static resetPageParam(searchParams) {
    const params = new URLSearchParams(searchParams);
    if (params.has("page")) {
      params.set("page", 1); // Set the page to 1
    } else {
      params.append("page", 1); // If no page param exists, add page=1
    }
    return params.toString();
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;

    // Update the page title dynamically based on the filter/sort
    FacetFiltersForm.updatePageTitle(searchParams);

    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById("ProductCountDesktop");
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

  }

  static updatePageTitle(searchParams) {
    const params = new URLSearchParams(searchParams);
    let newTitle = "Menopause Products – VERSALIE™️";

    document.title = newTitle;
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      });

    setTimeout(() => {
      const productGrid = document.getElementById("ProductGridContainer");
      if (productGrid) {
        const offset = 100;
        const elementPosition = productGrid.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 500);

  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);

    setTimeout(() => {
      const productGrid = document.getElementById("ProductGridContainer");
      if (productGrid) {
        const offset = 100;
        const elementPosition = productGrid.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 500);


  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id,
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => {
        return (
          !Array.from(facetDetailsElementsFromDom).some(
            (element2) => element2.id === element.id,
          ) || matchesId(element)
        );
      },
    );

    facetsToRender.forEach((element) => {
      document
        .getElementById(element.id)
        ?.setAttribute("open", true)
        ?.querySelector(".js-filter-content")
        ?.classList.remove("hidden");
      document.getElementById(element.id)?.replaceWith(element);
    });

    if (Shopify.designMode) {
      document
        .querySelectorAll(".shopify-section")
        .forEach((element) => element.classList.add("hidden"));
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll("facet-filters-form form");

    if (event.srcElement.className == "mobile-facets__checkbox") {
      let searchParams = this.createSearchParams(event.target.closest("form"));
      searchParams = FacetFiltersForm.resetPageParam(searchParams);
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            let formParams = this.createSearchParams(form);
            formParams = FacetFiltersForm.resetPageParam(formParams);
            forms.push(formParams);
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          let formParams = this.createSearchParams(form);
          formParams = FacetFiltersForm.resetPageParam(formParams);
          forms.push(formParams);
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
    FacetFiltersForm.toggleActiveFacets(false);
    FacetFiltersForm.closeSortDrawer();
    document.body.classList.remove("overflow-hidden");
    FacetFiltersForm.removeNoJsFacetElements();
    window.scrollTo(0, 0);
    FacetFiltersForm.updateURLHash(searchParams);
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const url = event.currentTarget.href.indexOf("?") == -1 ? "" : event.currentTarget.href.split("?")[1];
    FacetFiltersForm.renderPage(url);
  }

  static toggleActiveFacets(disable = true) {
    const activeFacets = document.querySelectorAll(".js-facet-remove");
    activeFacets.forEach((facet) => facet.classList.toggle("disabled", disable));
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
  }

  static removeNoJsFacetElements() {
    document.querySelectorAll(".no-js-facet").forEach((element) => element.remove());
  }

  static closeSortDrawer() {
    const sortDrawer = document.getElementById("SortDrawer");
    if (!sortDrawer) return;
    sortDrawer.classList.remove("translate-y-0");
    sortDrawer.classList.add("translate-y-full");
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }
}

customElements.define("facet-filters-form", FacetFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("max", 0);
    if (maxInput.value === "") minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define("facet-remove", FacetRemove);

class SortByContainer extends HTMLElement {
  constructor() {
    super();

    const dropdown = this.querySelector("select");
    if (!dropdown) return;

    dropdown.addEventListener("change", function () {
      let windowString = String(window.location);

      // Remove existing sort_by params
      let cleanSlate = windowString.replace(/[&?]sort_by=[^&]*/g, "");

      // Add the selected sort_by value
      let selectedValue = window.location.href.indexOf("?") > -1 ? "&sort_by=" + dropdown.value : "?sort_by=" + dropdown.value;

      // Reset the page parameter to 1
      const params = new URLSearchParams(cleanSlate.split('?')[1]);
      params.set("page", 1);

      // Update the URL
      window.location.replace(window.location.pathname + '?' + params.toString() + selectedValue);
    });
  }
}

customElements.define("sort-by-container", SortByContainer);
